import { Component, Input } from '@angular/core';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { AdditionOfManpowerService } from '../../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbDatepickerModule, NgbDateParserFormatter, NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../Model/Common/common.service';
import moment from 'moment';

@Component({
  selector: 'app-select-work-orderfor-reduction-new',
  standalone: true,
  imports: [NgbModule, FormsModule, CommonModule, LoaderComponent, NgbDropdownModule, NgSelectModule, NgbDatepickerModule, DataTablesModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './select-work-orderfor-reduction-new.component.html',
  styleUrl: './select-work-orderfor-reduction-new.component.scss'
})
export class SelectWorkOrderforReductionNewComponent {
  @Input() SiteID: number = 0;
  @Input() SiteName: string = '';
  @Input() ESS_ShiftWiseManpowerMasterId: number = 0;

  isDisabled: boolean = false;
  User: any = null;

  Sites: any[] = [];
  Designations: any[] = [];
  Dutys: any[] = [];
  Shifts: any[] = [];
  WorkOrders: any[] = [];
  Card = {
    Balance: 0,
    Reduction: 0,
    ApplyDate: null,
  }
  constructor(
    private comboload: ComboService,
    private session: SessionService,
    private utility: UtilityService,
    private siteadditionreduction: AdditionOfManpowerService,
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    protected common: CommonService,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    this.User = this.session.GetUserDetails();
  }

  Filter = {
    SiteID: null as any,
    DesignationID: null,
    DutyID: null,
    ShiftID: null,
    WorkOrderNo: null,
  }

  ngOnInit(): void {
    this.Filter.SiteID = this.SiteID;
    this.Sites.push({
      SiteMasterID: this.SiteID,
      SiteName: this.SiteName
    });
    this.ComboLoad('Designation');
    this.ComboLoad('Duty');
    this.ComboLoad('Shift');
  }

  Validate(form: any) {
    if (form.valid) {
      this.Load();
    } else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true

    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': 0,
      'ClientId': 0,
      'SiteId': this.Filter.SiteID,
      'DesignationId': 0,
      'EmpType': ''
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Designation') {
            this.Designations = response.ComboLoad;
          } else if (Combotype == 'Duty') {
            this.Dutys = response.ComboLoad;
          } else if (Combotype == 'Shift') {
            this.Shifts = response.ComboLoad;
          }
        }
        else {
          this.toast.show({ message: 'No Data is there in Load', type: toastTypeEnum.warning });
        }
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  Load() {
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet({
      SelectType: 'D',
      ESS_ShiftWiseManpowerMasterId: this.ESS_ShiftWiseManpowerMasterId,
      ESS_ShiftWiseManpowerDetailsId: 0,
      AllocationType: 'R',
      WoNo: this.Filter.WorkOrderNo,
      SiteId: this.Filter.SiteID,
      DesignationId: this.Filter.DesignationID,
      DutyId: this.Filter.DutyID,
      ShiftId: this.Filter.ShiftID
    }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.WorkOrders = Object.values(response.Table);
          this.WorkOrders.forEach(element => {
            element.FromDate = '';
            element.NoOfPerson = ''
          });
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
          this.isDisabled = false;
          this.WorkOrders = [];
        }
        this.CalculateTotol();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.WorkOrders = [];
        this.isDisabled = false;
      },
    });
  }

  CalculateTotol() {
    this.Card.Balance = this.WorkOrders.map(e => e.Balance).reduce((acc, cur) => acc + Number(cur), 0);
    this.Card.Reduction = this.WorkOrders.map(e => e.NoOfPerson).reduce((acc, cur) => acc + Number(cur), 0);
  }

  ApplyDates(){
    if(this.Card.ApplyDate != null && this.Card.ApplyDate != ''){
      this.WorkOrders.filter(e => e.NoOfPerson > 0 && (e.FromDate == null || e.FromDate == '')).forEach(element => {
        element['FromDate'] = this.Card.ApplyDate;
      });
    }
  }

  Cancel() {
    this.activeModal.close();
  }

  Ok() {
    if (this.WorkOrders.filter(e => parseInt(isNaN(e.NoOfPerson) ? 0 : e.NoOfPerson) > 0).length == 0) {
      this.toast.show({ message: "Please enter atleast one reduction count", type: toastTypeEnum.warning });
    } else if (this.WorkOrders.filter(e => parseInt(isNaN(e.NoOfPerson) ? 0 : e.NoOfPerson) > 0).findIndex(e => parseInt(e.Balance) < parseInt(e.NoOfPerson)) >= 0) {
      this.toast.show({ message: "Reduction count greater than balance not allow", type: toastTypeEnum.warning });
    } else if (this.WorkOrders.filter(e => parseInt(isNaN(e.NoOfPerson) ? 0 : e.NoOfPerson) > 0).findIndex(e => e.FromDate == "") >= 0) {
      this.toast.show({ message: "Reduction date can not be empty", type: toastTypeEnum.warning });
    } else if (this.WorkOrders.filter(e => parseInt(isNaN(e.NoOfPerson) ? 0 : e.NoOfPerson) > 0).findIndex(e => moment(e.AdditionDate).isAfter(moment(this.dateFormat.format(e.FromDate)))) >= 0) {
      this.toast.show({ message: "Reduction date less than addition date not allow", type: toastTypeEnum.warning });
    } else {
      this.WorkOrders.filter(e => e.NoOfPerson > 0).forEach(element => {
        element.RefESS_ShiftWiseManpowerDetailsId = element.ESS_ShiftWiseManpowerDetailsId;
        element.ESS_ShiftWiseManpowerDetailsId = 0;
        element.FromDate = element.FromDate != null && element.FromDate != '' ? this.dateFormat.format(element.FromDate) : '',
          element.ToDate = element.ToDate != null && element.ToDate != '' ? this.dateFormat.format(element.ToDate) : ''
        element.IsMonthLocked = 0;
      });
      this.activeModal.close(this.WorkOrders.filter(e => e.NoOfPerson > 0));
    }
  }

  minDate(date: string) {
    return this.dateFormat.parse(date);
  }
}
